module.exports = __webpack_public_path__ + "img/pep-smart-switch.ee4d9029.png";